"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

exports.Pinterest = function (props) {
  var _a;

  return react_1.default.createElement("svg", __assign({}, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-1220",
    d: "M37.55,30.43c-2.819,3.24-6.53,4.811-10.77,4.48c-2.28-0.18-3.59-1.08-4.97-2.04c-0.05-0.04-0.1-0.08-0.16-0.11 c-1.16,5.76-2.72,11.05-6.85,14.05l-1.35,0.98l-0.23-1.65c-0.98-6.949,0.53-12.569,1.99-18c0.49-1.819,0.95-3.55,1.32-5.31 c-1.32-2.57-1.16-6.33,0.42-9.11c1.52-2.66,4.03-3.69,6.62-2.66c4,1.58,2.55,6.14,1.39,9.81c-0.81,2.54-1.65,5.17-0.86,6.5 c0.31,0.53,0.91,0.88,1.83,1.07c0.351,0.06,0.69,0.1,1.03,0.1c3.3,0,5.12-3.49,5.75-4.99c2.021-4.84,1.59-11.1-0.94-13.67 C29.91,7.99,27.5,7,24.8,7c-3.48,0-7.08,1.69-9.4,4.42c-2.08,2.44-2.95,5.48-2.45,8.56c0.12,0.74,0.48,1.34,0.86,1.97 c0.82,1.34,1.83,3.01,0.15,5.99l-0.37,0.649l-0.72-0.16c-4.92-1.1-7.2-4.74-6.97-11.14C6.24,7.92,14.29,1.98,21.69,1.15 C22.6,1.05,23.53,1,24.43,1c9.37,0,16.4,5.26,17.47,13.1C42.74,20.14,41.07,26.4,37.55,30.43z"
  })), react_1.default.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-1220"
  }));
};